import { getExternalMentions } from '@connect-x-app/hybrid-data-access';
import { ExternalMention, MessageMention, MessageMentionType, QueryKeys } from '@connect-x-app/shared-domain-models';
import { useQuery } from '@tanstack/react-query';

import { useExternalMentionsStore } from '../../stores';
import { useAuthentication } from '../useAuthentication';

export const transformExternalMentionToMention = (externalMention: ExternalMention): MessageMention => {
  return {
    label: externalMention.displayName,
    roles: externalMention.roles.map(role => role.externalId),
    type: MessageMentionType.DISPLAY_NAME,
  };
};

export const useGetExternalMentions = () => {
  const { setExternalMentions } = useExternalMentionsStore();
  const { canMentionExternally } = useAuthentication();

  return useQuery<ExternalMention[]>({
    enabled: canMentionExternally,
    queryFn: async () => {
      const mentions = await getExternalMentions();
      const transformedExternalMention = mentions.map(transformExternalMentionToMention);
      setExternalMentions(transformedExternalMention);
      return mentions;
    },
    queryKey: [QueryKeys.MENTIONS],
  });
};
